"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InputSuffix_1 = __importDefault(require("./InputSuffix"));
exports.default = InputSuffix_1.default;
